<template lang="pug">
el-row(:gutter="50")
  el-col(:span="24")
    i.fa.fa-download
    span(@click="downloadGeometrias").download Download - Geometria de processos indeferidos e títulos cancelados.
  el-col(:span="24")
    i.fa.fa-download
    span(@click="downloadProcesso").download Download - Planilha de processos indeferidos e títulos cancelados.
</template>

<script>

import { mapActions } from 'vuex'

export default {

  methods: {
    ...mapActions({
      csvProcessosBloqueio: 'processos/csvProcessosBloqueio',
      shapeProcessosBloqueio: 'processos/shapeProcessosBloqueio'
    }),
    downloadGeometrias () {
      this.shapeProcessosBloqueio()
    },
    downloadProcesso () {
      this.csvProcessosBloqueio()
    }
  }
}
</script>
<style scoped lang="scss">
  .download {
    font-size: 1em !important;
    color: #000;
    line-height: 30px;
    margin-left: 10px;
  }
  .download:hover {
    font-size: 1em !important;
    color: #444343;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/AppMonitoramentoDeClausulasResolutivas.vue